import { useMemo, useEffect } from 'react';
import { getImageStyles } from './ImagePreviewStyles.js';
import { jsx } from '@emotion/react/jsx-runtime';

function ImagePreview(_ref) {
  let {
    image,
    ...rest
  } = _ref;
  const imageUrl = useMemo(() => typeof image === 'string' ? image : URL.createObjectURL(image), [image]);
  useEffect(() => {
    return () => {
      URL.revokeObjectURL(imageUrl);
    };
  }, [imageUrl]);
  return jsx("img", {
    "data-id": "image-preview",
    css: getImageStyles,
    src: imageUrl,
    alt: "",
    ...rest
  });
}

export { ImagePreview };
//# sourceMappingURL=ImagePreview.js.map
